<template>
    <div class="g11c-sticky" role="region" aria-label="إجراءات سريعة">
        <button
            type="button"
            class="g11c-sticky__btn g11c-sticky__btn--book"
            @click="$emit('cta', 'download')"
        >
            حمّل الكتاب
        </button>
        <router-link
            :to="introRoute"
            class="g11c-sticky__btn g11c-sticky__btn--primary"
            @click.native="$emit('cta', 'intro')"
        >
            ابدأ مجانًا
        </router-link>
        <router-link
            :to="monthOneRoute"
            class="g11c-sticky__btn g11c-sticky__btn--secondary"
            @click.native="$emit('cta', 'month1')"
        >
            الشهر الأول
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'CurriculumMobileSticky',
    props: {
        introRoute: { type: [Object, String], required: true },
        monthOneRoute: { type: [Object, String], required: true },
    },
};
</script>
